import { IonButton, IonIcon } from '@ionic/react';
import { ReactNode } from 'react';
import { informationCircle, warning, checkmarkCircle } from 'ionicons/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/pro-light-svg-icons';
import './AlertBanner.css';

export type AlertVariant = 'info' | 'warning' | 'error' | 'success';
type IonicAlertVariant = Exclude<AlertVariant, 'error'>;

export interface AlertBannerProps {
    variant: AlertVariant;
    message: ReactNode;
    action?: {
        label: string;
        onClick: () => void;
    };
}

export const AlertBanner: React.FC<AlertBannerProps> = ({ variant, message, action }) => {
    const getIonicIcon = (variant: IonicAlertVariant) => {
        const icons: Record<IonicAlertVariant, string> = {
            info: informationCircle,
            warning: warning,
            success: checkmarkCircle
        };
        return icons[variant];
    };

    return (
        <div className={`alert-banner alert-banner--${variant}`}>
            {variant === 'error' ? (
                <FontAwesomeIcon icon={faBan} className="alert-banner__icon" />
            ) : (
                <IonIcon
                    icon={getIonicIcon(variant as IonicAlertVariant)}
                    className="alert-banner__icon"
                />
            )}
            <span className="alert-banner__message">{message}</span>
            {action && (
                <IonButton
                    fill="solid"
                    size="small"
                    onClick={action.onClick}
                    className="alert-banner__button"
                    style={{
                        '--background': variant === 'error' ? '#dc2626' :
                            variant === 'warning' ? '#8b6d37' :
                                variant === 'info' ? '#719ab6' : '#576b4f'
                    }}
                >
                    {action.label}
                </IonButton>
            )}
        </div>
    );
}; 